import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import isEqual from 'lodash/isEqual'
import { change } from 'redux-form'

import { LocalSearchGrid } from 'shared/Helpers'

import { getAvailableOfficerList } from '../../store/loanOfficer'
import { FORM_NAME, LKGRID_NAME } from './constants'
import OpenDay from './OpenDay'

const LKGridConfig = {
  gridIdentity: {
    formName: 'frm_loan_manager_add',
    objectName: 'dbgrd_manager',
  },
  columnDefs: [
    { headerName: 'FullName', field: 'FullName' },
    { headerName: 'LoginFull', field: 'LoginFull' },
  ],
  instanceName: LKGRID_NAME,
  enableColumnsResize: true,
  enableColumnsOrder: true,
  syncGridState: true,
  selectFirstRow: true,
  enableRowSelection: true,
}

const SearchGrid = ({ manager }) => {
  const dispatch = useDispatch()

  const slice = useSelector(getAvailableOfficerList, isEqual)

  const handleChooseOfficer = React.useCallback(
    ({ node: { data, selected } }) => {
      if (!selected && manager === data.ID) {
        dispatch(change(FORM_NAME, 'ManagerID', ''))

        return
      }

      if (selected) {
        dispatch(change(FORM_NAME, 'ManagerID', data.ID))
      }
    },
    [manager, dispatch],
  )

  const handleInputChange = React.useCallback(
    (result) => {
      if (!result.length) {
        dispatch(change(FORM_NAME, 'ManagerID', ''))
      }
    },
    [dispatch],
  )

  return (
    <LocalSearchGrid
      data={slice.data}
      LKGridConfig={LKGridConfig}
      searchBy="FullName"
      onInputChange={handleInputChange}
      onRowSelected={handleChooseOfficer}
    >
      <OpenDay />
    </LocalSearchGrid>
  )
}

export default SearchGrid
